import { Typography, Container } from '@mui/material';
import GeneralProvisions from './GeneralProvisions';
import Definitions from './Definitions';
import TermsOfUseOfTheWebsite from './TermsOfUseOfTheWebsite';
import TechnicalRequirements from './TechnicalRequirements';
import Safety from './Safety';
import PrivacyAndCookiesPolicy from './PrivacyAndCookiesPolicy';
import Payments from './Payments';
import ComplaintProcedure from './ComplaintProcedure';
import FinalProvisions from './FinalProvisions';
import TechnicalRequirementsAndLiveChat from './TechnicalRequirementsAndLiveChat';
import AdministratorResponsibilityScopeChatbot from './AdministratorResponsibilityScopeChatbot';

const RegulationContent = () => (
  <Container disableGutters>
    <Typography variant="h4" fontWeight="700" sx={{ marginBottom: '10px' }}>
      Regulamin Serwisu BEST Online wraz ze zmianami
    </Typography>
    <Typography variant="h6" fontWeight="700" sx={{ marginBottom: '0' }}>
      obowiązujący od dnia 13 lutego 2025 r.
    </Typography>
    <GeneralProvisions />
    <Definitions />
    <TermsOfUseOfTheWebsite />
    <TechnicalRequirements />
    <TechnicalRequirementsAndLiveChat />
    <AdministratorResponsibilityScopeChatbot />
    <Safety />
    <PrivacyAndCookiesPolicy />
    <Payments />
    <ComplaintProcedure />
    <FinalProvisions />
  </Container>
);

export default RegulationContent;
